<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script setup>

</script>

<style>

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html, body {
  height: 100%;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
}

#app {
  height: 100vh;
}


/* :root {
  --color-primary: #0070f3;
  --color-primary-hover: #005cc5;
} */
</style>